"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Col = Col;

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _lodash = require("lodash");

var _index = require("../../index");

var _Breakpoint = require("./Breakpoint");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function Col(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  var flexGrow = props.flexGrow,
      flexShrink = props.flexShrink,
      order = props.order,
      width = props.width,
      tn = props.tn,
      sm = props.sm,
      md = props.md,
      lg = props.lg,
      gt = props.gt,
      hg = props.hg,
      className = props.className,
      passThroughProps = _objectWithoutProperties(props, ["flexGrow", "flexShrink", "order", "width", "tn", "sm", "md", "lg", "gt", "hg", "className"]);

  var baseClasses = colClasses(props);
  var breakpoints = (0, _lodash.pick)(props, Object.values(_Breakpoint.Breakpoint));
  var breakpointClasses = Object.keys(breakpoints).map(function (breakpoint) {
    return colClasses(_objectSpread({
      breakpoint: breakpoint
    }, breakpoints[breakpoint]));
  });
  var classes = (0, _classnames.default)(className, baseClasses, breakpointClasses);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classes
  }, passThroughProps), children);
}

function colClasses(_ref2) {
  var breakpoint = _ref2.breakpoint,
      props = _objectWithoutProperties(_ref2, ["breakpoint"]);

  var flexGrow = props.flexGrow,
      flexShrink = props.flexShrink,
      order = props.order,
      width = props.width;
  return (0, _classnames.default)(_defineProperty({}, _index.Classes.BASE_COL_CLASS, !breakpoint), _defineProperty({}, colClass('flex-grow', flexGrow, breakpoint), flexGrow), _defineProperty({}, colClass('flex-shrink', flexShrink, breakpoint), flexShrink), _defineProperty({}, colClass('order', order, breakpoint), order), _defineProperty({}, colClass('width', width, breakpoint), width));
}

function colClass(frowIdentifier, value, breakpoint) {
  return [_index.Classes.BASE_COL_CLASS, breakpoint ? "--".concat(breakpoint, "-") : '--', "".concat(frowIdentifier, "-"), value].join('');
}